import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../AppIcon';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle = ({ showLabel = false, variant = 'compact' }) => {
  const { mode, toggleMode, isDark } = useTheme();

  if (variant === 'full') {
    return (
      <div className="space-y-4">
        {/* Mode Toggle */}
        <div className="flex items-center justify-between p-4 bg-muted/50 rounded-xl">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
              <Icon name={isDark ? 'Moon' : 'Sun'} size={20} className="text-primary" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground">Modo de Tema</h3>
              <p className="text-xs text-muted-foreground">
                {isDark ? 'Modo Oscuro' : 'Modo Claro'}
              </p>
            </div>
          </div>
          <button
            onClick={toggleMode}
            className={`relative inline-flex h-8 w-14 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ${
              isDark ? 'bg-primary' : 'bg-muted'
            }`}
            aria-label="Toggle theme mode"
          >
            <motion.span
              className="inline-flex h-6 w-6 items-center justify-center transform rounded-full bg-white shadow-lg"
              animate={{ x: isDark ? 28 : 4 }}
              transition={{ type: 'spring', stiffness: 500, damping: 30 }}
            >
              <Icon name={isDark ? 'Moon' : 'Sun'} size={14} className="text-primary" />
            </motion.span>
          </button>
        </div>
        {/* P1+ Palette Preview */}
        <div className="p-4 bg-muted/50 rounded-xl">
          <div className="flex items-center space-x-3 mb-3">
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
              <Icon name="Palette" size={20} className="text-primary" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground">Paleta Prime One+</h3>
              <p className="text-xs text-muted-foreground">Azul → Teal</p>
            </div>
          </div>
          <div className="flex items-center gap-2 mt-2">
            <div
              className="w-8 h-8 rounded-lg"
              style={{ background: 'linear-gradient(135deg, #2E6FD8 0%, #1AAFB0 100%)' }}
              title="P1+ Gradient"
            />
            <div className="w-8 h-8 rounded-lg bg-[#2E6FD8]" title="Primary Blue" />
            <div className="w-8 h-8 rounded-lg bg-[#1AAFB0]" title="Accent Teal" />
            <div className="w-8 h-8 rounded-lg bg-[#1E8FD5]" title="Mid Blue" />
            <span className="text-xs text-muted-foreground ml-1">Paleta activa</span>
          </div>
        </div>
      </div>
    );
  }

  // Compact variant for header
  return (
    <div className="flex items-center space-x-2">
      <motion.button
        onClick={toggleMode}
        className="p-2.5 rounded-lg bg-muted/50 hover:bg-muted text-foreground hover:text-primary transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        title={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
        aria-label="Toggle theme mode"
      >
        <Icon name={isDark ? 'Sun' : 'Moon'} size={18} />
      </motion.button>
      {showLabel && (
        <span className="text-xs text-muted-foreground hidden lg:inline">
          {isDark ? 'Oscuro' : 'Claro'}
        </span>
      )}
    </div>
  );
};

export default ThemeToggle;